export function registerCookieBanner(Alpine) {
    Alpine.data('cookieBanner', () => ({
        showBanner: false,

        init() {
            // Перевіряємо, чи користувач вже зробив вибір
            if (!localStorage.getItem('itez_cookie_consent')) {
                // Невелика затримка для кращого UX (щоб банер не з'являвся миттєво)
                setTimeout(() => { this.showBanner = true }, 500);
            }
        },

        acceptCookies() {
            localStorage.setItem('itez_cookie_consent', 'accepted');
            this.showBanner = false;
        },

        declineCookies() {
            localStorage.setItem('itez_cookie_consent', 'declined');
            this.showBanner = false;
        }
    }));
}
